import { generatePath } from 'react-router';

const patterns = {
  root: '/',
  health: '/health',
  signIn: '/auth/sign-in',
  signUp: '/auth/sign-up',
  selectOrganization: '/onboarding/select-organization',
  createOrganization: '/onboarding/create-organization',
  dashboard: '/dashboard',
  members: '/dashboard/members',
  member: '/dashboard/members/:userId',
  addMember: '/dashboard/members/add',
  properties: '/dashboard/properties',
  addProperty: '/dashboard/properties/add',
  updateProperty: '/dashboard/properties/:propertyId/update',
  property: '/dashboard/properties/:propertyId',
  propertyUnits: '/dashboard/properties/:propertyId/units',
  addPropertyUnit: '/dashboard/properties/:propertyId/units/add',
  updatePropertyUnit: '/dashboard/properties/:propertyId/units/:unitId/update',
  propertyNotes: '/dashboard/properties/:propertyId/notes',
} as const;

export const ROUTE_PATTERNS = patterns;

export const PATHS = {
  root: patterns.root,
  health: patterns.health,
  signIn: patterns.signIn,
  signUp: patterns.signUp,
  selectOrganization: patterns.selectOrganization,
  createOrganization: patterns.createOrganization,
  dashboard: patterns.dashboard,
  members: patterns.members,
  member: (userId: string): string => generatePath(patterns.member, { userId }),
  addMember: patterns.addMember,
  properties: patterns.properties,
  addProperty: patterns.addProperty,
  updateProperty: (propertyId: string): string => generatePath(patterns.updateProperty, { propertyId }),
  property: (propertyId: string): string => generatePath(patterns.property, { propertyId }),
  propertyUnits: (propertyId: string): string => generatePath(patterns.propertyUnits, { propertyId }),
  addPropertyUnit: (propertyId: string): string => generatePath(patterns.addPropertyUnit, { propertyId }),
  updatePropertyUnit: (propertyId: string, unitId: string): string =>
    generatePath(patterns.updatePropertyUnit, { propertyId, unitId }),
  propertyNotes: (propertyId: string): string => generatePath(patterns.propertyNotes, { propertyId }),
};
